import { useState, useCallback } from "react";

const STORAGE_KEY = "sbp_recently_viewed";
const MAX_ITEMS = 5;

export interface RecentProduct {
  id: string;
  title: string;
  price: number;
  originalPrice: number;
  image: string;
  category: string;
  badge: string;
}

function loadFromStorage(): RecentProduct[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as RecentProduct[];
  } catch {
    return [];
  }
}

function saveToStorage(items: RecentProduct[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
}

export function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] = useState<RecentProduct[]>(loadFromStorage);

  const addRecentlyViewed = useCallback((product: RecentProduct) => {
    setRecentlyViewed((prev) => {
      const filtered = prev.filter((p) => p.id !== product.id);
      const updated = [product, ...filtered].slice(0, MAX_ITEMS);
      saveToStorage(updated);
      return updated;
    });
  }, []);

  const clearRecentlyViewed = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setRecentlyViewed([]);
  }, []);

  return { recentlyViewed, addRecentlyViewed, clearRecentlyViewed };
}
